const provinceDrop = document.querySelector('#form_province');
const dropCity = document.querySelector('#form_city');

const findStores = (e) => {
    e.preventDefault();
    const selectedProvince = provinceDrop.value;
    const selectedCity = dropCity.value;
    if(selectedProvince != 'all' && selectedProvince != 'online'){
        document.querySelectorAll('.result-item').forEach((item, idx) => {
            const itemProvince = item.getAttribute('data-province');
            const itemCity = item.getAttribute('data-city');
            if(!item.classList.contains('result-item-hidden')){
                item.classList.add('result-item-hidden');
            }

            if(itemProvince == selectedProvince){
                if(itemCity == selectedCity || selectedCity == '') {
                    item.classList.remove('result-item-hidden'); 
                }
            }
        });
    }else if(selectedProvince == 'online'){
      document.querySelectorAll('.result-item').forEach((item, idx) => {
            const itemWebsite = item.getAttribute('data-website');

            if(!item.classList.contains('result-item-hidden')){
                item.classList.add('result-item-hidden');
            }

            if(itemWebsite != ''){
               item.classList.remove('result-item-hidden'); 
            }
        });
    }else {
        viewAllStore();
    }
}

const viewAllStore = () => {
    document.querySelectorAll('.result-item-hidden').forEach((item, idx) => {
        item.classList.remove('result-item-hidden');
    });
}

const provincesList = [];

const addCity = (province, city) => {
    const hasCity = province.cities.find((x) => {return x == city});
    if(!hasCity){
        province.cities.push(city);
    }
}

const loadCities = (e) => {
    const selected = e.target.value;
    dropCity.innerHTML = '<option value="">Todas as cidades</option>';
    if(selected != '' && selected != 'all'){
        const citiesList = provincesList.find((x) => {return x.province == selected}).cities;
        citiesList.forEach((city, idx) => {
            const item = document.createElement('option');
            item.setAttribute('value', city);
            item.innerHTML = city;
            dropCity.appendChild(item);
        })
        dropCity.removeAttribute('disabled');
    }else{
        dropCity.setAttribute('disabled', 'disabled');
    }
}

const loadProvinceSelect = () => {
    
    // contentFaqs.appendChild(faq);
    if(provincesList.length > 0){
        provincesList.forEach((provinceItem, idx) => {
            const item = document.createElement('option');
            item.setAttribute('value', provinceItem.province);
            item.innerHTML = provinceItem.province;
            provinceDrop.appendChild(item);
        });
      
        //add online
        const online = document.createElement('option');
        online.setAttribute('value', 'online');
        online.innerHTML = 'Online';
        provinceDrop.appendChild(online);
      
        //add todos
        const all = document.createElement('option');
        all.setAttribute('value', 'all');
        all.innerHTML = 'Ver todos';
        provinceDrop.appendChild(all);

    }
}

const initWhereFind = () => {
    document.querySelectorAll('.result-item').forEach((item, idx) => {
        const currentProvince = item.getAttribute('data-province');
        const currentCity = item.getAttribute('data-city');
        const hasProvince = provincesList.find((x) => {return x.province == currentProvince});
        if(hasProvince){
            addCity(hasProvince, currentCity)
        }else{
            const province = {
                province: currentProvince,
                cities: []
            }
            addCity(province, currentCity);
            provincesList.push(province);
        }
    });
    loadProvinceSelect();
}

document.addEventListener('DOMContentLoaded', function() {
    // load all provinces and cities
    const complementStores = document.querySelectorAll('.lagarh-where-find-complement .result-item');
    if(complementStores.length > 0){
        complementStores.forEach((item, idx) => {
            document.querySelector('.lagarh-where-find-load-stores').appendChild(item);
        });
    }
    initWhereFind();
});